import { render, staticRenderFns } from "./BDXManagementTable.vue?vue&type=template&id=a41b5f96&scoped=true"
import script from "./BDXManagementTable.vue?vue&type=script&lang=js"
export * from "./BDXManagementTable.vue?vue&type=script&lang=js"
import style0 from "./BDXManagementTable.vue?vue&type=style&index=0&id=a41b5f96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a41b5f96",
  null
  
)

export default component.exports